import React from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import PreLoginPage from '../../../views/core/PreLoginPage';
import HmAjax from '../../../util/HmAjax';
import ProductConfig from '../../../config/ProductConfig.json';

// ES6 class-style
class Experience extends PreLoginPage {
	constructor(props) {
	    super(props);

	     this.state = {
	      error: null,
	      isLoaded: false,
	      items: [],
	      ProductList: [],
	      pro_detail: [],
	      products : [],
	      self: [],
	      plp:[],
	      products_details: {},
	      products_category_order:[]
	    };
	    this.grades = this.props.grades;
	    this.productClass = this.props.products_class;
	    this.productDetails = this.props.products_details;
	    this.products_category = this.props.products_category;
	    this.productClasses = this.props.classes;
	    this.state.products = (Object.keys(this.products_category));
	  }
	
	 componentDidMount() {
	  	const { products,self,plp } = this.state;
	  	this.grades = this.props.grades;
	  	this.productClass = this.props.products_class;
	  	this.productDetails = this.props.products_details;
	  	this.products_category = this.props.products_category;
	  	this.productClasses = this.props.classes;
	  	this.state.products = (Object.keys(this.products_category));
	  }
	 getProdDetails(){
	   	//console.log(this.state.products_details);
	  	if(this.state.products_details !== {} && this.state.products_details !== undefined){
	      return this.state.products_details;
	    }
	  }

	  saveID(grade,proID,link){
		  const {products_details} = this.state;
	  	var me =this;
	  	var callBackSuccess = function(result){
		if(result !== null){
			
			me.setState({
	          products_details: result
	        }),
	       //console.log("Footer:::",me.getProdDetails());
	       	localStorage.setItem('grade',grade);
	  		localStorage.setItem('product',proID);
	        localStorage.setItem('proDetail',JSON.stringify(me.getProdDetails()));

	        window.top.location.href=link;

		}

		//console.log("response : ", response);
		}
	
		var callBackFailure = function(response){
			me.setState({
			    isLoaded: true,
			    error:"Error in Footer PRODUCT_JSON"
			  });
			console.log("Error in Footer PRODUCT_JSON in Grade");		
		}
	
		var formData = {
				"levelId":grade
		}
		new HmAjax(this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);
		
		//console.log(grade);
	  	//console.log(proID);
	  	
	  }
	  renderFooterProduct(product,grade){
  		//console.log(product,", ",grade,", ",this.products_category);
  		if(this.products_category[product].hasOwnProperty(grade)){
  			//console.log(this.productClasses[grade].ClassName);
  			var restricted = ""
  			if(this.GradeRestrictionManager.isGradeRestricted(grade)){
  				restricted = "restricted";
  			}
  			return (<div className="col-6 plr-5">
  						<div data-ga={'Home -  Product - '+ProductConfig[product].ganame+' - '+this.productClasses[grade].ClassName + ' - Direct link'}  onClick={() => this.saveID(`${grade}`,`${this.products_category[product][grade]}`,ProductConfig[product].url+this.products_category[product][grade])} className={"mbt-5 classbtn "+restricted}>
  							{this.productClasses[grade].ClassName}
  							{(() => {
									if(restricted == "restricted"){
										return "*";
									}
							})()}
  						</div>
  					</div>
  					);		   
  		}  		
  	 }
	 checkRestrictedGrade(product,grades){
  		//console.log("grades:::",grades, ", ",product);
  		//console.log(this.products_category, ", ",product,", ",this.products_category[product],", ",this.products_category[product].hasOwnProperty("11"));
		var restrictedAvailable = false;
		if(grades && grades.length > 0){			
			for(var i=0;i<grades.length;i++){
				if(this.products_category[product].hasOwnProperty(grades[i])){
		  			if(this.GradeRestrictionManager.isGradeRestricted(grades[i])){
		  				restrictedAvailable = true;
		  				break;
		  			}
				}
			}
		}else{ restrictedAvailable = true; }
		
		return restrictedAvailable;
  		/*if(restrictedAvailable){
  			return (<div className="col-12 text-center smallinfo">
  						*Available only for desktop
  					</div>
  					);	   
  		}*/  		
  	 }
  render() {
	 const { products,self,plp } = this.state;
  	this.grades = this.props.grades;
  	this.grades_order = this.props.grades_order;
  	this.productClass = this.props.products_class;
  	this.productDetails = this.props.products_details;
  	this.products_category = this.props.products_category;
  	this.productClasses = this.props.classes;
  	this.state.products = (Object.keys(this.products_category));
  	this.state.products_category_order = this.props.products_category_order;
  	return(
	<section className="experience mtb">
		<div className="container">
				<h3>{this.rb("custom.label.txt.2")}</h3>
				{/* <h4>Experience our programs now</h4> */}
				<h4>{this.rb("experience.heading")}</h4>
			<div className="prod-list clearfix text-center"> 
				
				{(() => {
					if(this.checkRestrictedGrade(ProductConfig.SPL.productKey,this.grades) == false){
						return(
							<div className="pro-box pro-box-home float-left">
								<div className="e-box e-h2">
									<span><img src="../img/e1.png" alt=""/></span>
									<h2>Self-Paced Lessons</h2>
									<hr className="h-line"/>
									<p>To build a strong conceptual foundation</p>						
						            	
											{(() => {
												if(this.state.products_category_order.indexOf(ProductConfig.SPL.productKey) > -1){
													return(
														<div>
														<div className="col-10 mx-auto no-padding row notopbottommargin classlistPool">											
															{
																this.grades.map(grade => (
																		this.renderFooterProduct(ProductConfig.SPL.productKey,grade)	
																))
															}												
														</div>
														
														</div>
													);
												}
											})()}
								</div>
							</div> 
						);
					}
				})()}
				
				{(() => {
					if(this.checkRestrictedGrade(ProductConfig.PLP.productKey,this.grades) == false){
						return(
							<div className="pro-box pro-box-home  float-left">
								<div className="e-box">
									<span><img src="../img/e3.png" alt=""/></span>
									<h2>Personalised Learning </h2>
									<hr className="h-line"/>
									<p>To build confidence through continuous progress</p>
									
											{(() => {
												if(this.state.products_category_order.indexOf(ProductConfig.PLP.productKey) > -1){
													return(
														<div>
														<div className="col-10 mx-auto no-padding row notopbottommargin classlistPool">
															{
																this.grades.map(grade => (
																		this.renderFooterProduct(ProductConfig.PLP.productKey,grade)	
																))
															}
															
														</div>											
														</div>
													);
												}
											})()}
								</div>
							</div>
						);
					}
				})()}
				
				
				{(() => {
					if(this.checkRestrictedGrade(ProductConfig.EXAM_PREP_CBSE.productKey,this.grades) == false){
						return(
							<div className="pro-box pro-box-home  float-left">
								<div className="e-box">
									<span><img src="../img/e2.png" alt=""/></span>
									<h2>CBSE Exam Prep</h2>
									<hr className="h-line"/>
									<p>To achieve your best in the board exams</p>
									
											{(() => {
												if(this.state.products_category_order.indexOf(ProductConfig.EXAM_PREP_CBSE.productKey) > -1){
													return(
														<div>
														<div className="col-10 mx-auto no-padding row notopbottommargin pti-15 classlistPool">
															{
																this.grades.map(grade => (
																		this.renderFooterProduct(ProductConfig.EXAM_PREP_CBSE.productKey,grade)	
																))
															}												
														</div>														
														</div>
													);
												}
											})()}							
								</div>
							</div>
						);
					}
				})()}
				
			</div>	
			
			{/* <div className="mt-30 text-center">
				<a data-ga="Home - Customise to your schools test calendar" className="surveylink" href="https://www.surveymonkey.com/r/L6THKSD" target="_blank" >Customise to your school's test calendar <i className="material-icons">link</i></a>
			</div> */}
		</div>
	</section>
  	);
  }
}

export default Experience;



// WEBPACK FOOTER //
// ./src/prelogin/src/components/Experience.js